import Seo from "@/components/common/Seo";
import Footer from "@/components/common/footer";
import { Navbar } from "@/components/common/navbar";
import { useScrollToTop } from "@/hooks/useScrollToTop";
import { cn } from "@/lib/utils";

type Props = {
  children: React.ReactNode;
  title?: string;
  description?: string;
  keywords?: string;
  className?: string;
};

export default function DefaultLayout({
  children,
  title,
  description,
  keywords,
  className,
}: Props) {
  useScrollToTop();

  return (
    <div className="relative flex flex-col h-screen">
      <Seo description={description} keywords={keywords} title={title} />
      <div className="bg-[#16181b]">
        <Navbar />
        <main className={cn("pt-0", className)}>{children}</main>
        <Footer />
      </div>
    </div>
  );
}
